import { render, staticRenderFns } from "./workDetail.vue?vue&type=template&id=ec7c58a0&scoped=true&"
import script from "./workDetail.vue?vue&type=script&lang=js&"
export * from "./workDetail.vue?vue&type=script&lang=js&"
import style0 from "./workDetail.vue?vue&type=style&index=0&id=ec7c58a0&scoped=true&lang=css&"
import style1 from "./workDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7c58a0",
  null
  
)

export default component.exports